import { useEffect, useState } from "react";
import useAuthStore from "../../store/useAuthStore";
import { useProfileUpdateStore } from "../../store/useProfileUpdateStore";
import { useUserStore } from "../../store/useUserStore";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Email = () => {
  const { activeSection, setActiveSection, updateProfile } = useProfileUpdateStore();
  const authStore = useAuthStore.getState();
  const userId = authStore.user.id;
  const user = useUserStore((state) => state.user);
  const getUserDetails = useUserStore((state) => state.getUserDetails);

  // Local State for Controlled Inputs
  const [email, setEmail] = useState(user?.email || "");

  // Define the type for errors
  const [errors, setErrors] = useState<{
    email?: string;
  }>({});

  useEffect(() => {
    if (!user || user.id !== userId) {
      getUserDetails(userId);
      console.log(user);
      
      
    }
    setEmail(user?.email || "");
  }, [userId, user, getUserDetails]);

  if (activeSection !== "email") return null;

  // Email validation function
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Validate Fields
  const validateForm = () => {
    const newErrors: {
      email?: string;
    } = {};
    if (!email) {
      newErrors.email = "Email is required.";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Invalid email format.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    const updatedData = {
      email: {
        email,
      },
    };

    await updateProfile(userId, updatedData);
    toast.success("Information updated successfully!");
    getUserDetails(userId);
     setActiveSection(null); // Optionally close section after saving
  };

  return (
    <div className="col-lg-4">
                    <div className="card p-lg-4 p-3 border rounded-4 mb-3">
                                        <div className="border-bottom pb-3 mb-3 d-flex w-100 align-items-center gap-3">
                                            <h4 className="mb-0">Update Email</h4>
                                            <button className="btn_close_cross_btn ms-auto " onClick={() => setActiveSection(null)}>
                                                <i className="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                        <label className="form-label mb-2 font600 font18">Email</label>
                                        <input className="form-control" type="email" placeholder=""
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)} />
                                          {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}   
                                        <button className="btn btn-outline-primary w-100 mt-4" onClick={handleSave}>
                                            Save Changes</button>
                                    </div>


  
    </div>
  );
};

export default Email;
